var _a;
import { __decorate, __metadata, __param } from "tslib";
import { SpaceTemplatesRepository } from './space-templates-repository.interface';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
let SpaceTemplatesServiceImpl = class SpaceTemplatesServiceImpl {
    constructor(_spaceTemplatesRepository) {
        this._spaceTemplatesRepository = _spaceTemplatesRepository;
    }
    querySpaceTemplates() {
        return this._spaceTemplatesRepository.querySpaceTemplates();
    }
};
SpaceTemplatesServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpaceTemplatesRepository)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpaceTemplatesRepository !== "undefined" && SpaceTemplatesRepository) === "function" ? _a : Object])
], SpaceTemplatesServiceImpl);
export { SpaceTemplatesServiceImpl };
